import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { parseApiError } from '@app/shared/models/api/api-error.model';
import { getApiEndpoint } from '@app/shared/utils/url.utils';
import { Observable, catchError, throwError, map } from 'rxjs';
import { PaymentConfigurationModel } from '../models/payment-configuration.model';

@Injectable({ providedIn: 'root' })
export class PaymentConfigurationApiService {
  private readonly http = inject(HttpClient);

  constructor() {}

  public getPaymentConfigurationsApi(
    country: string
  ): Observable<Array<PaymentConfigurationModel> | null> {
    // eslint-disable-next-line deprecation/deprecation
    const apiUrl: string = getApiEndpoint('api/v2/payment/configurations', true);

    // eslint-disable-next-line deprecation/deprecation
    const credentials = btoa(`api:GKbwgZ9rJBf8oggS`);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Basic ${credentials}`,
    });

    return this.http
      .get<any>(
        // Assemble the full API URL
        apiUrl,
        // Add the Options
        {
          responseType: 'json',
          headers: headers,
          params: {
            country: country,
            client: 'WEB',
          },
        }
      )
      .pipe(
        catchError((error: unknown) => throwError(() => parseApiError(error))),
        map((data) => PaymentConfigurationModel.fromJsonArray(data))
      );
  }

  public getRankedPaymentConfigurationsApi(
    orderId: string
  ): Observable<Array<PaymentConfigurationModel> | null> {
    // eslint-disable-next-line deprecation/deprecation
    const apiUrl: string = getApiEndpoint('api/v2/payment/configurations/rank', true);

    // eslint-disable-next-line deprecation/deprecation
    const credentials = btoa(`api:GKbwgZ9rJBf8oggS`);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Basic ${credentials}`,
    });

    return this.http
      .get<any>(
        // Assemble the full API URL
        apiUrl,
        // Add the Options
        {
          responseType: 'json',
          headers: headers,
          params: {
            order_id: orderId,
            client: 'WEB',
          },
        }
      )
      .pipe(
        catchError((error: unknown) => throwError(() => parseApiError(error))),
        map((data) => PaymentConfigurationModel.fromJsonArray(data))
      );
  }
}
